import givingOrgs from './givingOrgs';
export default {
  givingOrgs,
};
